import React, { useEffect } from "react";
import { Link, NavLink, Route, Routes, useLocation, useNavigate, useParams } from "react-router-dom"
import AllG from "view/panel/guests";
import { getGuest } from "../../../services/getApi";
import { Countdown } from "../../../utils/Countdown";
import Guest from "../../../view/panel/Guest";
import Reports from "../../../view/panel/reports";
import RoomPrice from "../../../view/panel/roomPrice";
import Setting from "../../../view/panel/setting";
import Navbar from "../../common/navabr/navbar";
import Table from "../../common/table";
import Print from "../print.layout";

const breadcrumbs = {
    "":['گزارش ها'],
    "new-guest":['ثبت مهمان'],
    "new-guest":['ثبت مهمان'],
    "setting":['تنظیمات'],
    "room-price":['مدیریت قیمت اتاق‌ها'],
}

function Panel() {
    const redirect = useNavigate();
    const location = useLocation()
    const path1 = window.location.pathname.substring(0, 10)
    const [change, setChane] = React.useState(new Date());
    const [loading, setLoading] = React.useState(false);

    const handleLogout = () => {
        localStorage.removeItem("token");
        localStorage.removeItem("validityTime");
        redirect('/login');
    }

    const handleReportPage = () => {
        redirect("/")
        setChane(new Date());
    }


    return (
        <div>
            <Navbar
                loading={loading}
                path1={path1}
                handleReportPage={handleReportPage}
                handleLogout={handleLogout}
            />
            <div className="text-sm breadcrumbs mr-5 mt-5">
                <ul>
                    <li><span className="text-[#fff5]">پنل مدیرتی</span></li>
                    {
                        breadcrumbs[location.pathname.split("/")[1]]?.map(i=> (
                            <li><span className="font-bold text-[#eee]">{i}</span></li>
                        ))
                    }
                </ul>
            </div>
            <div className="mt-[0px]">
                {/* -------------------------------------------------------------------------------- */}
                {/* -------------------------------------------------------------------------------- */}
                {/* -------------------------------------------------------------------------------- */}
                {/* Route -------------------------------------------------------------------------- */}
                <Routes>
                    <Route path="/" element={<Reports change={change} setLoading={setLoading} />} />
                    <Route path='guests' element={<AllG change={change} setLoading={setLoading} />} />
                    <Route path='print/:id' element={<Print />} />
                    <Route path='new-guest' element={<Guest />}>
                        <Route path="person" />
                        <Route path="room" />
                        <Route path="check" />
                    </Route>
                    <Route path='room-price' element={<RoomPrice />} />
                    <Route path='setting' element={<Setting />} />
                </Routes>
                {/* ------------------------------------------------------------------------------------ */}
                {/* ------------------------------------------------------------------------------------ */}
                {/* ------------------------------------------------------------------------------------ */}
                {/* ------------------------------------------------------------------------------------ */}
            </div>
            <input type="checkbox" id="my-modal" className="modal-toggle" />
            <div className="modal">
                <div className="modal-box">
                    <h3 className="font-bold text-lg">آیا میخواهید از حساب خود خارج شوید؟</h3>
                    <p className="py-4 text-sm">در غیر این صورت خیر بزنید.</p>
                    <div className="modal-action flex-row-reverse flex-start">
                        <label for="my-modal" className="btn btn-outline btn-error" onClick={handleLogout}>تایید و خارج شدن</label>
                        <label for="my-modal" className="btn btn-outline mr-auto">خیر</label>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default Panel;
